import {
  CameraFilled,
  CheckOutlined,
  FolderOpenOutlined,
  LineOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Col, Row, Image, Button } from "antd";
import "../App.css";

import anamBase from "../images/magno_front.png";
import TestUI, { TestUIStim } from "./TestUI";
import { PosturalExamination, PosturalTestDefinition } from "./interfaces";
import { photoNotTakenYet, TakenPhoto } from "./PosturalExamWrapper";
import { useRef } from "react";

const PosturalExamAnamRight = ({
  page,

  testDefinitions,
  posturalExamination,
  setTestSelection,
}: {
  page: number;

  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
}) => {
  if (testDefinitions && testDefinitions.length > 0)
    testDefinitions.sort((td1, td2) => td1.id - td2.id);

  return (
    <>
      {page == 0 && (
        <>
          <Row className="ant-row-exam">
            <Col span={24}>
              {testDefinitions.length > 0 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 0 ? testDefinitions[0] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 0
                      ? posturalExamination.testSelections[0]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={7}>
              {testDefinitions.length > 1 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 1 ? testDefinitions[1] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 1
                      ? posturalExamination.testSelections[1]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={1}></Col>
            <Col span={7}>
              {testDefinitions.length > 2 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 2 ? testDefinitions[2] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 2
                      ? posturalExamination.testSelections[2]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={1}></Col>
            <Col span={7}>
              {testDefinitions.length > 3 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 3 ? testDefinitions[3] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 3
                      ? posturalExamination.testSelections[3]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>

            <Col span={11}>
              {testDefinitions.length > 4 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 4 ? testDefinitions[4] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 4
                      ? posturalExamination.testSelections[4]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              {testDefinitions.length > 5 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 5 ? testDefinitions[5] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 5
                      ? posturalExamination.testSelections[5]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
          </Row>
        </>
      )}

      {page == 1 && ( //page 1
        <>
          <Row>
            <Col span={11}>
              {testDefinitions.length > 6 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 6 ? testDefinitions[6] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 6
                      ? posturalExamination.testSelections[6]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              {testDefinitions.length > 7 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 7 ? testDefinitions[7] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 7
                      ? posturalExamination.testSelections[7]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>

            <Col span={24}>
              {testDefinitions.length > 8 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 8 ? testDefinitions[8] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 8
                      ? posturalExamination.testSelections[8]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={11}>
              {testDefinitions.length > 9 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 9 ? testDefinitions[9] : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 9
                      ? posturalExamination.testSelections[9]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              {testDefinitions.length > 10 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 10
                      ? testDefinitions[10]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 10
                      ? posturalExamination.testSelections[10]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
          </Row>
        </>
      )}
      {page == 2 && ( //page 2
        <>
          <Row>
            <Col span={11}>
              {testDefinitions.length > 11 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 11
                      ? testDefinitions[11]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 11
                      ? posturalExamination.testSelections[11]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              {testDefinitions.length > 14 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 14
                      ? testDefinitions[14]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 14
                      ? posturalExamination.testSelections[14]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={24}>
              {testDefinitions.length > 12 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 12
                      ? testDefinitions[12]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 12
                      ? posturalExamination.testSelections[12]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>

            <Col span={24}>
              {testDefinitions.length > 13 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 13
                      ? testDefinitions[13]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 13
                      ? posturalExamination.testSelections[13]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
          </Row>
        </>
      )}
      {page == 3 && ( //page 3
        <>
          <Row>
            <Col span={24}>
              {testDefinitions.length > 15 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 15
                      ? testDefinitions[15]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 15
                      ? posturalExamination.testSelections[15]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={11}>
              {testDefinitions.length > 17 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 17
                      ? testDefinitions[17]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 17
                      ? posturalExamination.testSelections[17]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>

            <Col span={2}></Col>
            <Col span={11}>
              {testDefinitions.length > 18 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 18
                      ? testDefinitions[18]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 18
                      ? posturalExamination.testSelections[18]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
          </Row>
        </>
      )}
      {page == 4 && ( //page 4
        <>
          <Row>
            <Col span={24}>
              {testDefinitions.length > 19 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 19
                      ? testDefinitions[19]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 19
                      ? posturalExamination.testSelections[19]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={24}>
              {testDefinitions.length > 20 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 20
                      ? testDefinitions[20]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 20
                      ? posturalExamination.testSelections[20]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
            <Col span={24}>
              {testDefinitions.length > 21 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 21
                      ? testDefinitions[21]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 21
                      ? posturalExamination.testSelections[21]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
          </Row>
        </>
      )}
      {page == 5 && ( //page 5
        <>
          <Row>
            <Col span={24}>
              {testDefinitions.length > 22 && (
                <TestUI
                  testDefinition={
                    testDefinitions.length > 22
                      ? testDefinitions[22]
                      : undefined
                  }
                  testSelection={
                    posturalExamination.testSelections &&
                    posturalExamination.testSelections.length > 22
                      ? posturalExamination.testSelections[22]
                      : undefined
                  }
                  setTestSelection={setTestSelection}
                  allInOneLine={false}
                  allowMultiSelection={true}
                />
              )}
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default PosturalExamAnamRight;
